import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  overflow: auto;
  padding-bottom: 9rem;
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 0.8rem 0 1.8rem;

  @media (min-width: 761px) {
    padding: 0;
  }
`;

export const ActionsRow = styled.div`
  display: flex;
  align-items: center;
`;

export const IconWrapper = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 4.4rem;
  width: 4.4rem;
  background-color: transparent;
  border: none;
  outline: none;
`;
